import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import { useFormContext } from 'react-hook-form'

import { CseInput } from '../../../lib/types/models/cse/cse'
import ControlledSwitch from '../../elements/controlled-switch'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../elements/inputs/controlled-phone-input'

const CseGeneralContactInfoFormSection = () => {
  const form = useFormContext<CseInput>()
  return (
    <InnerBox title="Coordonnées générales du CSE" className="rounded-xl">
      <div className="flex flex-col gap-3 ">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} label="Email" type="email" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledPhoneInput
                  {...field}
                  value={field.value}
                  label="Numéro de téléphone"
                  defaultCountry="FR"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className="h-4" />
      <FormField
        control={form.control}
        name={'canReceiveEmails'}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ControlledSwitch
                {...field}
                switchVariant="primary"
                label="Le CSE peut-il recevoir des e-mails ?"
                variant={'label-medium'}
                color={tailwindColors.black.DEFAULT}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default CseGeneralContactInfoFormSection
